"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryGasRecording_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrugDosageType_1 = require("./SurgeryDrugDosageType");
var SurgeryGas_1 = require("./SurgeryGas");
var SurgeryGasRecording_Factory = /** @class */ (function () {
    function SurgeryGasRecording_Factory() {
    }
    SurgeryGasRecording_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AssociatedOnRecordId: model.AssociatedOnRecordId,
            Flow: model.Flow,
            IsOn: model.IsOn,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgeryDrugDosageType: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateIncoming(model.SurgeryDrugDosageType),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryGas: SurgeryGas_1.SurgeryGas_Factory.CreateIncoming(model.SurgeryGas),
            SurgeryGasId: model.SurgeryGasId,
        };
        return result;
    };
    SurgeryGasRecording_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AssociatedOnRecordId: model.AssociatedOnRecordId,
            Flow: model.Flow,
            IsOn: model.IsOn,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SurgeryDrugDosageType: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateOutgoing(model.SurgeryDrugDosageType),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryGas: SurgeryGas_1.SurgeryGas_Factory.CreateOutgoing(model.SurgeryGas),
            SurgeryGasId: model.SurgeryGasId,
        };
        return result;
    };
    return SurgeryGasRecording_Factory;
}());
exports.SurgeryGasRecording_Factory = SurgeryGasRecording_Factory;
